import { render, staticRenderFns } from "./Framework.vue?vue&type=template&id=3ccaf03f"
import script from "./Framework.vue?vue&type=script&lang=js"
export * from "./Framework.vue?vue&type=script&lang=js"
import style0 from "./Framework.vue?vue&type=style&index=0&id=3ccaf03f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports